import React from 'react';

import { ScreenContainer, ScreenHeader } from 'ui/component';
import { KeyToSuccessCircle, StartJourneyCircle } from '../../component';
import { useNavigationContext } from '../../context';
import { useEricssonGTM } from '../../hook';
import classNames from './EABDHomeScreen.module.scss';

export const HomeScreen = React.memo(() => {
  const { push } = useNavigationContext();
  const ericssonGTM = useEricssonGTM();

  const OnStartJourneyButtonPressCallback = React.useCallback(() => {
    push('journey');
    ericssonGTM.onStartJourneyClick();
  }, [push, ericssonGTM]);
  const OnKeyToSuccessButtonPressCallback = React.useCallback(() => push('key_to_success'), [push]);

  return (
    <ScreenContainer>
      <ScreenHeader shouldShowHome={false}>
        <p className={classNames.headline}>{''}</p>
      </ScreenHeader>
      <div className={classNames.content}>
        <StartJourneyCircle onButtonPress={OnStartJourneyButtonPressCallback} />
        <div className={classNames.line} />
        <KeyToSuccessCircle onButtonPress={OnKeyToSuccessButtonPressCallback} />
      </div>
    </ScreenContainer>
  );
});
